var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUaelang({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1660_884)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    rx: 7.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-8 -4H24V20H-8V-4Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-8 -4V4H24V-4H-8Z",
    fill: "#5EAA22"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-8 12V20H24V12H-8Z",
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -8,
    y: -4,
    width: 10,
    height: 24,
    fill: "#E31D1C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1660_884"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    rx: 7.5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUaelang);
export default __webpack_public_path__ + "static/media/uaelang.30888b9c3f12a02d602d1475aea46797.svg";
export { ForwardRef as ReactComponent };